<section class="bg-white w-full">
  <p-menubar [model]="[]" styleClass="!border-0 !py-0 !px-4">

    <ng-template #start>
      <a routerLink="/" class="flex items-center mr-8 shrink-0">
        <img src="assets/img/logos.jpg" alt="Avana logo" class="h-[42px] max-[576px]:h-[38px] block">
      </a>
      <nav class="hidden min-[993px]:flex items-center">
        @for (item of leftMenuItems(); track item.label) {
        @if (item.path) {
        <a [routerLink]="item.path" routerLinkActive="border-b-2 border-main"
          class="flex items-center h-[52px] px-3 text-sm font-medium text-main cursor-pointer hover:bg-slate-100">
          {{ item.label }}
        </a>
        } @else {
        <span class="flex items-center h-[52px] px-3 text-sm font-medium text-main">
          {{ item.label }}
        </span>
        }
        }
      </nav>
    </ng-template>

    <ng-template #end>
      <div class="flex items-center">

        <nav class="hidden min-[993px]:flex items-center">
          @for (tab of rightMenuItems(); track tab.label) {
          @if (tab.path) {
          <a [routerLink]="tab.path" routerLinkActive="border-b-2 border-main"
            class="flex items-center h-[52px] px-3 text-sm font-medium text-main cursor-pointer hover:bg-slate-100">
            {{ tab.label }}
          </a>
          } @else {
          <span class="flex items-center h-[52px] px-3 text-sm font-medium text-main">
            {{ tab.label }}
          </span>
          }
          }
        </nav>

        <div
          class="hidden min-[993px]:flex gap-3 items-center h-[52px] pl-6 ml-4 border-0 border-l border-solid border-Gray-400 cursor-pointer select-none"
          (click)="menu.toggle($event)">
          <p-avatar [label]="userInitials()" shape="circle" />
          <div class="flex flex-col leading-tight">
            <span class="text-sm font-medium text-main truncate max-w-[200px]">
              {{ userProfileData()?.firstName }} {{ userProfileData()?.lastName }}
            </span>
            @if (creditUnionName()) {
            <span class="text-xs text-Gray-800 truncate max-w-[200px]">{{ creditUnionName() }}</span>
            }
          </div>
          <i class="pi pi-angle-down transition-transform duration-200" [ngClass]="{'rotate-180': isMenuOpen}"></i>
        </div>
        <p-menu #menu [model]="accountItems" [popup]="true" styleClass="!w-auto min-w-[15rem] max-w-[20rem]">
          <ng-template #start>
            <div class="flex flex-col gap-2 px-3 py-4 bg-Gray-100">
              <p class="font-bold">{{ userProfileData()?.firstName }} {{ userProfileData()?.lastName }}</p>
              @if (creditUnionName()) {
              <p>{{ creditUnionName() }}</p>
              }
              @if (hasMultipleCreditUnions()) {
              <a class="flex items-center gap-2 text-accent-success no-underline cursor-pointer w-fit"
                (click)="openChangeCreditUnion()">
                <i class="material-symbols-rounded text-brand">sync</i>
                <span>Change credit union</span>
              </a>
              }
            </div>
          </ng-template>
          <ng-template #item let-item>
            <a pRipple class="flex items-center gap-2 px-3 py-4 no-underline cursor-pointer" (click)="item.command()">
              <i class="material-symbols-rounded" [ngClass]="{'text-accent-red': item.id === 'logout'}">{{ item.icon
                }}</i>
              <span [ngClass]="{'text-accent-red': item.id === 'logout'}">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>

        <button
          class="flex min-[993px]:hidden items-center justify-center w-12 h-12 bg-transparent border-0 cursor-pointer"
          (click)="toggleSidenav.emit()">
          <i class="material-symbols-rounded">menu</i>
        </button>

      </div>
    </ng-template>

  </p-menubar>
</section>
